import { render, staticRenderFns } from "./addSubcategory.vue?vue&type=template&id=1a05df60"
import script from "./addSubcategory.vue?vue&type=script&lang=js"
export * from "./addSubcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports